import { GrpcRestFetchTransport, useAuth0Interceptor } from '@deepup/api-utils';
import { environment } from '@core/environment';
import { useEffect } from 'react';
import { proxy } from 'valtio';

// Valtio state for transport
interface TransportState {
  transport: GrpcRestFetchTransport | null;
}

const transportState = proxy<TransportState>({
  transport: null,
});

// Set transport in Valtio state
export const setTransport = (transport: GrpcRestFetchTransport) => {
  transportState.transport = transport;
};

// Get transport from Valtio state (can be used in any function, not just React components)
export const getTransport = (): GrpcRestFetchTransport => {
  if (!transportState.transport) {
    throw new Error('Transport not initialized');
  }
  return transportState.transport;
};

// Hook to create a transport instance
export const useGrpcTransport = () => {
  const authInterceptor = useAuth0Interceptor();
  const transport = new GrpcRestFetchTransport({
    baseUrl: environment.unifiedApiUrl,
    fetchInit: {
      credentials: 'include',
    },
    interceptors: [authInterceptor],
  });

  return { transport };
};

export const useSetupGrpcTransport = () => {
  const { transport } = useGrpcTransport();
  useEffect(() => {
    setTransport(transport);
  }, [transport]);
};
